/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	maximumLengthValidator,
	maximumStringLengthValidationMessage
} from '@entity/entity-formly-definitions';
import {
	IValidator
} from '@shared/interfaces/application-objects/validator.interface';
import {
	BaseRuleValidator
} from '@shared/validators/base-rule-validator.validator';

/**
 * A class representing a maximum length validator.
 *
 * @export
 * @class MaximumLengthValidator
 * @extends {BaseRuleValidator}
 */
export class MaximumLengthValidator
	extends BaseRuleValidator
{
	/**
	 * Creates and returns a unique instance of a maximum length validator.
	 *
	 * @returns {IValidator}
	 * A validator ready for use in a Formly layout.
	 * @memberof MaximumLengthValidator
	 */
	public create(): IValidator
	{
		return <IValidator>
			{
				expression: maximumLengthValidator,
				message: maximumStringLengthValidationMessage
			};
	}
}